import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';

interface TimeoutEventRequest {
    eventType: 'idle_timeout';
    reason: string;
    metadata: {
        idleDurationSeconds: number;
    };
}

@Injectable({
    providedIn: 'root',
})
export class TimeoutLoggingService {
    constructor(private _http: ApplicationHttpClient) {}

    logIdleTimeout(idleDurationSeconds: number): Observable<void> {
        const request: TimeoutEventRequest = {
            eventType: 'idle_timeout',
            reason: `User was idle for ${idleDurationSeconds} seconds`,
            metadata: {
                idleDurationSeconds: idleDurationSeconds,
            },
        };

        const url = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.TimeoutEvent);

        return this._http.post<void>(url, JSON.stringify(request)).pipe(
            catchError((error) => {
                console.error('Failed to log timeout event:', error);
                return of(void 0);
            }),
        );
    }
}
